<template>
  <section class="content-html" v-if="config.attrs && config.attrs.html" v-html="config.attrs.html">
  </section>
</template>

<script>
export default {
  name: 'HtmlString',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/standard';
</style>